export const IMG_MAX_HEIGHT = 600; //px
